import { getColor } from '../Theme/selectors';
import { convertStyleValue } from '../../utils/js-style-to-css';
var typographyPropsToCss = function typographyPropsToCss(_ref) {
  var uiTheme = _ref.uiTheme,
    align = _ref.align,
    color = _ref.color,
    family = _ref.family,
    letterSpacing = _ref.letterSpacing,
    lineHeight = _ref.lineHeight,
    opacity = _ref.opacity,
    size = _ref.size,
    transform = _ref.transform,
    weight = _ref.weight;
  return "\n    ".concat(align ? "text-align: ".concat(align, ";") : '', "\n    ").concat(color ? "fill: ".concat(getColor(uiTheme, color), ";") : '', "\n    ").concat(color ? "color: ".concat(getColor(uiTheme, color), ";") : '', "\n    ").concat(family ? "font-family: ".concat(family, ";") : '', "\n    ").concat(size ? "font-size: ".concat(convertStyleValue(size, 'fontSize'), ";") : '', "\n    ").concat(weight ? "font-weight: ".concat(weight, ";") : '', "\n    ").concat(letterSpacing ? "letter-spacing: ".concat(letterSpacing, ";") : '', "\n    ").concat(lineHeight ? "line-height: ".concat(lineHeight, ";") : '', "\n    ").concat(opacity ? "opacity: ".concat(opacity, ";") : '', "\n    ").concat(transform ? "text-transform: ".concat(transform, ";") : '', "\n");
};
export default typographyPropsToCss;